'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _electronActions = require('../../../../../../common/electron/electronActions');

var _Spinner = require('../../../../../components/loaders/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

var _LinkButton = require('../../../../../components/buttons/LinkButton');

var _LinkButton2 = _interopRequireDefault(_LinkButton);

var _electronUpdateSelector = require('./electronUpdateSelector');

var _electronUpdateSelector2 = _interopRequireDefault(_electronUpdateSelector);

var _electronConstants = require('../../../../../../common/electron/electronConstants');

require('./ElectronAppStatus.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchInstallUpdate: function dispatchInstallUpdate() {
            return dispatch((0, _electronActions.autoUpdateInstallUpdate)());
        },
        dispatchForcePoll: function dispatchForcePoll() {
            return dispatch((0, _electronActions.autoUpdateForcePoll)());
        }
    };
};

var UpdateStatus = function UpdateStatus(_ref) {
    var autoUpdate = _ref.autoUpdate,
        dispatchInstallUpdate = _ref.dispatchInstallUpdate,
        dispatchForcePoll = _ref.dispatchForcePoll;

    switch (autoUpdate) {
        case _electronConstants.AUTOUPDATE_STATE.DOWNLOADING:
            return _react2.default.createElement(
                'div',
                { className: 'downloading' },
                _react2.default.createElement(_Spinner2.default, { show: true }),
                ' ',
                'Downloading update...'
            );
        case _electronConstants.AUTOUPDATE_STATE.CHECKING:
            return _react2.default.createElement(
                'div',
                { className: 'downloading' },
                _react2.default.createElement(_Spinner2.default, { show: true }),
                ' ',
                'Checking for update...'
            );
        case _electronConstants.AUTOUPDATE_STATE.READY:
            return _react2.default.createElement(
                'div',
                { className: 'ready' },
                _react2.default.createElement(
                    'span',
                    { className: 'bullet' },
                    '\u25CF'
                ),
                ' ',
                _react2.default.createElement(
                    _LinkButton2.default,
                    { onClickFn: dispatchInstallUpdate },
                    'Install update'
                ),
                ' ',
                '(this will restart the app)'
            );
        case _electronConstants.AUTOUPDATE_STATE.ERROR:
            return _react2.default.createElement(
                'div',
                { className: 'error' },
                _react2.default.createElement(
                    'span',
                    { className: 'bullet' },
                    '\u25B2'
                ),
                ' Error downloading update',
                ' ',
                _react2.default.createElement(
                    _LinkButton2.default,
                    { onClickFn: dispatchForcePoll },
                    'Retry'
                )
            );
        default:
            return _react2.default.createElement(
                'div',
                { className: 'up-to-date' },
                _react2.default.createElement(
                    'span',
                    { className: 'bullet' },
                    '\u2714\uFE0E'
                ),
                ' Up to date'
            );
    }
};

var ElectronAppStatus = function ElectronAppStatus(props) {
    return _react2.default.createElement(
        'div',
        { className: 'ElectronAppStatus' },
        _react2.default.createElement(
            'div',
            null,
            'Milanote version ',
            _react2.default.createElement(
                'strong',
                null,
                props.version
            )
        ),
        _react2.default.createElement(UpdateStatus, props)
    );
};

ElectronAppStatus.propTypes = UpdateStatus.propTypes = {
    autoUpdate: _react2.default.PropTypes.string,
    version: _react2.default.PropTypes.string,
    dispatchInstallUpdate: _react2.default.PropTypes.func,
    dispatchForcePoll: _react2.default.PropTypes.func
};

exports.default = (0, _reactRedux.connect)(_electronUpdateSelector2.default, mapDispatchToProps)(ElectronAppStatus);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/account/electronApp/ElectronAppStatus.js
// module id = 2173
// module chunks = 0